import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { AppSettings } from '../../../settings/index';
import { AuthHttp } from '../../../common/index';

@Injectable()
export class UserService {
    constructor(private http: AuthHttp) { }

    getGetUserById(userId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('userId', userId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'User/GetUserById', options)
            .map((response: Response) => response.json());
    }

    getGetUsersWithName() {
        return this.http.get(AppSettings.apiEndpoint + 'User/GetUsersWithName')
            .map((response: Response) => response.json());
    }

    isCustodian() {
        return this.http.get(AppSettings.apiEndpoint + 'User/IsCustodian')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/security/user.service.ts